import React from 'react';

import * as Core from '../../../core';
import ManageGatewayAccount from './manageGatewayAccount';

const Ach = (): JSX.Element => <ManageGatewayAccount paymentGatewayId={Core.Models.PaymentGateway.Stripe} />;

export default Ach;
